const GroupRelationshipQueryKeys = {
  global: ["groupRelationships"] as const,

  /**
   * List
   */
  list: (ids: string[]) =>
    [...GroupRelationshipQueryKeys.global, "list", ...ids] as const,

  /**
   * By Account
   */
  byGroup: (groupId: string) =>
    [...GroupRelationshipQueryKeys.global, "group", groupId] as const,
};

export { GroupRelationshipQueryKeys };
